import { render, staticRenderFns } from "./BuyerActions.vue?vue&type=template&id=6cd92168"
import script from "./BuyerActions.vue?vue&type=script&lang=js"
export * from "./BuyerActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports